import React from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Col, Row } from "../Grid-system";
const AddImage = ({
  type,
  id,
  title,
  name,
  accept,
  onChange,
  oldImage,
  newImage,
  oldPDF,
  newPDF,
  oldVideo,
  newVideo,
  newImages,
  clickDeleteImage,
  clickDeleteImages,
  clickDeleteImage2,
  clickDeleteVideo,
  className,
}) => {
  return (
    <>
      <input
        id={id || "image"}
        type="file"
        name={name}
        onChange={onChange}
        className="hidden"
        accept={
          type === "IMAGES"
            ? "image/*"
            : type === "VIDEO"
            ? "video/*"
            : type === "PDF"
            ? "application/pdf"
            : accept
            ? accept
            : "image/*"
        }
      />
      <div
        onClick={() => document.getElementById(id || "image").click()}
        className={`w-full flex justify-between text-[#9CA3AF] border-2 my-2 py-[9px] rounded-xl border-Main px-5 cursor-pointer mx-1 ${className}`}
      >
        <div className=""> {title || "أضف صورة"}</div>
        <div>
          <AiOutlineCloudUpload size={30} className="text-Main" />
        </div>
      </div>
      {type === "IMAGES" && newImages ? (
        <Row className="py-4">
          {newImages &&
            newImages?.map((e, i) => (
              <Col lg={3} sm={6}>
                <div className="relative">
                  <span
                    onClick={clickDeleteImages || clickDeleteImage2}
                    className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                  >
                    X
                  </span>
                  <img src={e} alt="" className="w-[250px] rounded-2xl" />
                </div>
              </Col>
            ))}
        </Row>
      ) : type === "VIDEO" && (oldVideo || newVideo) ? (
        <Row>
          {oldVideo && (
            <Col md={6}>
              <video controls className="rounded-2xl w-32 h-32">
                <source src={oldVideo} />
              </video>
            </Col>
          )}
          {newVideo && (
            <Col md={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteVideo}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <video controls className="rounded-2xl">
                  <source src={newVideo} />
                </video>
              </div>
            </Col>
          )}
        </Row>
      ) : type === "PDF" && (oldPDF || newPDF) ? (
        <Row>
          {oldPDF && (
            <Col xm={6}>
              <a href={oldPDF}>عرض الملف القديم</a>
            </Col>
          )}
          {newPDF && <Col xm={6}>{newPDF}</Col>}
        </Row>
      ) : (
        <Row justify="center" className="pt-3">
          {newImage && (
            <Col col={6}>
              <div className="relative">
                <span
                  onClick={clickDeleteImage}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <img
                  src={newImage}
                  alt=""
                  className="w-[250px] h-[250px] rounded-2xl"
                />
              </div>
            </Col>
          )}
          {oldImage && (
            <Col md={6}>
              <img
                src={oldImage}
                alt=""
                className="w-[250px] h-[250px] rounded-2xl"
              />
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default AddImage;
